module.exports = __webpack_public_path__ + "static/img/watermark.f50c7ef8.png";